/**
 * Localization messages for RoleCard component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Ignore Role': 'roleRecs.roleCard.ignoreRole',
  'Ignore Role?': 'roleRecs.roleCard.ignoreRoleModalTitle',
  "Are you sure you want to ignore this role recommendation? You can't get it back once it's gone.":
    'roleRecs.roleCard.ignoreRoleModalSubtitle',
  'Role Includes:': 'roleRecs.card.roleIncludes',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RoleCardMessage = keyof typeof invertedMessages;

export default invertedMessages;
